// Exact values from theme.css --fs-* / --fw-* variables.
export const FontFamily = {
  sans: 'IBM Plex Sans',
  mono: 'IBM Plex Mono',
} as const;

export const FontSize = {
  xs: 12,
  sm: 13,
  md: 14, // body
  lg: 16,
  xl: 20,
  '2xl': 24,
  '3xl': 30,
  '4xl': 40,
} as const;

export const FontWeight = {
  regular: '400' as const,
  medium: '500' as const,
  semibold: '600' as const,
  bold: '700' as const,
};

export const LineHeight = {
  tight: 1.25,
  normal: 1.45, // body
  relaxed: 1.6,
} as const;
